document.addEventListener("DOMContentLoaded", function() {
    document.getElementsByTagName("body")[0].classList.remove("preload");
});  